const TAKE_LATEST = 'takeLatest';

export default function normalizeModifiers(modifiers, modifier) {
	return Object.keys(modifier).length ? modifier : modifiers.length ? {name: TAKE_LATEST} : {};
}
